<ng-template #resultsPanel>
  <div class="global-search__panel" role="listbox">
    <div class="global-search__heading" *ngIf="isShowingRecentEntries">Recently searched</div>
    <div class="global-search__heading" *ngIf="!isShowingRecentEntries && normalizedSearchTerm.length >= 3">
      Suggested {{ localizedLabel.Candidates | localizeText }}
    </div>

    <div class="global-search__loading" *ngIf="isLoading" aria-live="polite">
      <span class="global-search__spinner" aria-hidden="true"></span>
      <span class="sr-only">Loading</span>
    </div>

    <ng-container *ngIf="!isLoading && isShowingRecentEntries">
      <div
        class="global-search__result"
        *ngFor="let entry of recentEntries; let index = index; trackBy: trackByEntryId"
        [class.active]="activeIndex === index"
        [id]="'global-search-' + instanceId + '-option-' + index"
        role="option"
        [attr.aria-selected]="activeIndex === index"
        (mouseenter)="activeIndex = index"
        (click)="activateRecent(entry)">
        <i class="m-icon global-search__result-icon" *ngIf="entry.type === 'search'" aria-hidden="true">search</i>
        <span class="global-search__avatar op-avatar" *ngIf="entry.type === 'profile'">
          <img *ngIf="entry.imageUrl" [src]="entry.imageUrl" alt="">
        </span>
        <span class="global-search__copy">
          <strong>{{ entry.type === 'search' ? entry.searchTerm : entry.displayName }}</strong>
          <span *ngIf="entry.type === 'profile' && entry.defaultJobRole">{{ entry.defaultJobRole }}</span>
        </span>
        <button
          type="button"
          class="global-search__remove"
          title="Remove from recent searches"
          aria-label="Remove from recent searches"
          (click)="removeRecent($event, entry)">
          <i class="m-icon" aria-hidden="true">close</i>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading && !isShowingRecentEntries && normalizedSearchTerm.length >= 3">
      <button
        type="button"
        class="global-search__result"
        *ngFor="let suggestion of suggestions; let index = index; trackBy: trackByCandidateId"
        [class.active]="activeIndex === index"
        [id]="'global-search-' + instanceId + '-option-' + index"
        role="option"
        [attr.aria-selected]="activeIndex === index"
        (mouseenter)="activeIndex = index"
        (click)="activateSuggestion(suggestion)">
        <span class="global-search__avatar op-avatar">
          <img *ngIf="suggestion.imageUrl" [src]="suggestion.imageUrl" alt="">
        </span>
        <span class="global-search__copy">
          <strong>{{ suggestionDisplayName(suggestion) }}</strong>
          <span *ngIf="suggestion.defaultJobRole">{{ suggestion.defaultJobRole }}</span>
        </span>
      </button>

      <button type="button" class="global-search__see-all" *ngIf="hasMore" (click)="seeAllResults()">
        See all results
        <i class="m-icon" aria-hidden="true">arrow_forward</i>
      </button>
    </ng-container>
  </div>
</ng-template>

<ng-container *ngIf="mobile; else desktopSearch">
  <button
    type="button"
    class="global-search__mobile-trigger"
    title="Search"
    [attr.aria-label]="'Search ' + (localizedLabel.Candidates | localizeText)"
    (click)="openMobile()">
    <i class="m-icon" aria-hidden="true">search</i>
  </button>

  <div class="global-search__mobile-shell" *ngIf="isOpen">
    <div class="global-search__mobile-bar">
      <button type="button" class="global-search__back" title="Back" aria-label="Back" (click)="close(true)">
        <i class="m-icon" aria-hidden="true">arrow_back</i>
      </button>
      <div class="global-search__field">
        <i class="m-icon" aria-hidden="true">search</i>
        <input
          #searchInput
          type="search"
          autocomplete="off"
          placeholder="Search"
          [(ngModel)]="searchTerm"
          [attr.aria-label]="'Search ' + (localizedLabel.Candidates | localizeText)"
          [attr.aria-expanded]="isOpen"
          [attr.aria-activedescendant]="activeDescendantId"
          (ngModelChange)="onSearchTermChanged()"
          (keydown)="onKeydown($event)">
      </div>
    </div>
    <ng-container *ngTemplateOutlet="resultsPanel"></ng-container>
  </div>
</ng-container>

<ng-template #desktopSearch>
  <div class="global-search__desktop" [class.expanded]="desktopExpanded">
    <button
      type="button"
      class="global-search__desktop-trigger"
      title="Search"
      [attr.aria-label]="'Search ' + (localizedLabel.Candidates | localizeText)"
      [attr.aria-expanded]="isOpen"
      (click)="openDesktop()">
      <i class="m-icon" aria-hidden="true">search</i>
    </button>
    <div class="global-search__field global-search__desktop-field">
      <i class="m-icon" aria-hidden="true">search</i>
      <input
        #searchInput
        type="search"
        autocomplete="off"
        placeholder="Search"
        [(ngModel)]="searchTerm"
        [attr.aria-label]="'Search ' + (localizedLabel.Candidates | localizeText)"
        [attr.aria-expanded]="isOpen"
        [attr.aria-activedescendant]="activeDescendantId"
        (focus)="open()"
        (click)="open()"
        (ngModelChange)="onSearchTermChanged()"
        (keydown)="onKeydown($event)">
    </div>
    <ng-container *ngIf="isOpen">
      <ng-container *ngTemplateOutlet="resultsPanel"></ng-container>
    </ng-container>
  </div>
</ng-template>
